import fetch from "cross-fetch";

const BASE_URL = process.env.REACT_APP_CONTENTFUL_API_URL_BASE;
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;

class ContentfulApi {
  getLandingPageFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appLandingPageFields`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getCollectionPageFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appCollectionPageFields`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getCollectionPageNecklaceFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appCollectionPageFieldsNecklace`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getConfiguratorPageFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appConfiguratorPageFields`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getConfiguratorPageNecklaceFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appConfiguratorPageFieldsNecklace`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getSummaryPageFields = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=appSummaryPageFields`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getCollections = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=collection`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getMainRings = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=mainRing`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getHolderRings = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=holderRing`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getNecklaces = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=necklace`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };

  getMemories = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/${SPACE_ID}/environments/master/entries?content_type=memory`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + ACCESS_TOKEN,
          },
        }
      );
      if (response.ok) {
        return response.json();
      } else {
        const message = `An error has occured: ${response.status}`;
        return new Error(message);
      }
    } catch (error) {
      return error;
    }
  };
}

export default ContentfulApi;
